function config(env=process.env.NODE_ENV) {
    // 定義各種環境下使用的參數，勿任意更動
    var urls = {
        development: {
            action_cable_url: "ws://localhost:3000",
            lms_url: "http://localhost:3000",
        },
        production: {
            action_cable_url: "wss://api.tw568.com",
            lms_url: "https://api.tw568.com",
        }
    }

    // 輸出規則，預設為參照env，可將env更換為"production"或"development"
    var output_rules = {
        action_cable_url: env,
        lms_url: env,
    }

    // 按照Rule組成結果，勿任意更動
    var result = {};
    Object.keys(output_rules).map(function(parameter_name, index) {
        var current_parameter_environment = output_rules[parameter_name];
        result[parameter_name] = urls[current_parameter_environment][parameter_name];
    });
    return result;
}

module.exports = config;
